function Attachment(t){var e={getMimeType:function(){return t.mimeType},getData:function(){return t.data}};return e}module.exports=Attachment;